import styled from 'styled-components';
import { ButtonConfirm } from '../../components/ButtonConfirm';
import { colors } from '../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-width: 480px;

  background-color: ${colors.surfaceContainerLow};

  @media (max-width: 1199px) {
    min-width: auto;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  padding: 28px;
`;

export const ContainerText = styled.div`
  margin: 20px 0;
`;

export const Text = styled.p`
  font-size: 15px;
  color: ${colors.onSurfaceVariant};
  margin-bottom: 12px;
  line-height: 1.5;

  span {
    font-weight: 700;
    color: ${colors.onSurface};
  }
`;

export const Button = styled(ButtonConfirm)`
  align-self: center;
  margin: 20px auto;
`;
